const urlencode = (str) =>{
      str = str.replace(/%/g, '%25');
      str = (str + '').toString();
      return encodeURIComponent(str).
      replace(/!/g, '%21').
      replace(/'/g, '%27').
      replace(/\(/g, '%28').
      replace(/\)/g, '%29').
      replace(/\*/g, '%2A').
      //replace(/\ /g, '%20').
      replace(/%20/g, '+').
      replace(/%25/g, '%');
}
export default urlencode